// Holds a reference to the initialized Transmit drs module.
// Populated by initTransmit() on the client; remains null in SSR.
let drs = null

export function getDrs () {
  return drs
}

export function setDrs (drsRef) {
  drs = drsRef
}
